import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean, dropTipoEndereco } from 'utils/drops';
import { decryptURL } from 'utils/functions';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Gerar = () => {
  const rotina = 'Ceendereco';
  const defaultValues = {
    celocal_id: null,
    endereco: '',
    tipo: null,
    posicao: '',
    x: '',
    y: '',
    altura: '',
    largura: '',
    comprimento: '',
    picking: 'SIM',
    ativo: 'SIM',
  };
  const navigate = useNavigate();
  const { hash } = useParams();
  const decrypt = decryptURL(hash);
  const { drops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset({ ...defaultValues, ...decrypt });
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => navigate(-1),
    });

  return (
    <Container>
      <Header
        titulo={
          (Boolean(decrypt?.id) ? 'Editar' : 'Adicionar') +
          ' Endereço de Estoque'
        }
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="celocal_id"
              control={control}
              label="Local de Estoque"
              options={drops?.LocalEstoque}
              disabled={Boolean(decrypt?.id)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="endereco"
              control={control}
              label="Endereço de Estoque"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Dropdown
              name="tipo"
              control={control}
              label="Tipo"
              options={dropTipoEndereco}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Input name="posicao" control={control} label="Posição" />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Input name="x" control={control} label="X" type="number" />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Input name="y" control={control} label="Y" type="number" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Input
              name="altura"
              control={control}
              label="Altura"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Input
              name="largura"
              control={control}
              label="Largura"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Input
              name="comprimento"
              control={control}
              label="Comprimento"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="picking"
              control={control}
              label="Picking"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="ativo"
              control={control}
              label="Ativo"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Gerar;
